/* Keep official Afterpay messaging off the hero's initial rendering path. */
(() => {
  if (window.GrowplayPaymentMessaging) return;
  const sdkUrl = 'https://js.squarecdn.com/square-marketplace.js';
  let started = false;
  let observer;
  const seen = new WeakSet();

  function load() {
    if (started) return;
    started = true;
    observer?.disconnect();
    const existing = document.querySelector(`script[src="${sdkUrl}"]`);
    if (existing) return;
    const script = document.createElement('script');
    script.src = sdkUrl;
    script.async = true;
    script.onload = () => document.dispatchEvent(new CustomEvent('gp:payment-messaging-ready'));
    script.onerror = () => {
      script.remove();
      started = false;
      // A later explicit customization action can retry a transient failure.
    };
    document.head.append(script);
  }

  function observe(root) {
    if (started) return;
    if (!observer) {
      observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) load();
      }, {rootMargin: '200px 0px'});
    }
    root.querySelectorAll('square-placement').forEach(placement => {
      // The undefined web component may have no box before its SDK loads.
      // Observe the reserved payment row instead of that empty custom element.
      const target = placement.closest('.gp-frame-primary-bnpl, .cpb-afterpay-mount') || placement.parentElement;
      if (!target || seen.has(target)) return;
      seen.add(target);
      observer.observe(target);
    });
  }

  function afterHero() {
    const image = document.querySelector('.product-gallery__main img');
    const imageReady = image?.decode ? image.decode().catch(() => {}) : Promise.resolve();
    // A failed/slow image must not prevent the payment message from loading.
    let timer;
    const timeout = new Promise(resolve => {timer = setTimeout(resolve, 2500);});
    Promise.race([imageReady, timeout]).then(() => {
      clearTimeout(timer);
      requestAnimationFrame(() => requestAnimationFrame(() => observe(document)));
    });
  }

  document.addEventListener('gp:frame-builder-visibility', event => {
    if (event.detail?.visible) load();
  });
  document.addEventListener('shopify:section:load', event => observe(event.target));
  window.GrowplayPaymentMessaging = {load};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', afterHero, {once: true});
  else afterHero();
})();
